import { useEffect } from 'react';
import { Button, Modal } from 'semantic-ui-react';
import { useDeleteBlockTagMutation } from 'api/tagsApi';
import { ErrorMessage } from 'components/error-message';

type Props = {
  tagEntry: {
    tag: string;
    count: number;
  } | null;
  onClose(): void;
};

export function BlockTagDeleteModal({ tagEntry, onClose }: Props) {
  const { error, isLoading, mutateAsync, reset } = useDeleteBlockTagMutation();

  useEffect(() => {
    reset();
  }, [reset, tagEntry?.tag]);

  if (!tagEntry) {
    return null;
  }

  const handleClose = () => {
    if (isLoading) {
      return;
    }

    reset();
    onClose();
  };

  const handleDelete = async () => {
    try {
      await mutateAsync(tagEntry.tag);
      reset();
      onClose();
    } catch {
      // The mutation state already exposes the error in the dialog.
    }
  };

  return (
    <Modal open size="tiny" onClose={handleClose} closeOnDimmerClick={!isLoading} closeOnEscape={!isLoading}>
      <Modal.Header>Delete tag?</Modal.Header>
      <Modal.Content>
        <p>
          Are you sure you want to delete the tag <strong>{tagEntry.tag}</strong> from {tagEntry.count} {tagEntry.count === 1 ? 'block' : 'blocks'}?
        </p>
        <ErrorMessage error={error ?? null} />
      </Modal.Content>
      <Modal.Actions>
        <Button color="black" onClick={handleClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button negative onClick={handleDelete} loading={isLoading} disabled={isLoading}>
          Delete
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
